module.exports = __webpack_public_path__ + "location-default-image.svg?7ab52faf887f453d8ae77f7157f7451d";